.container {
  padding-bottom: 90px;
}

.image {
  object-fit: cover;
  width: 90px;
  height: 90px;
  border-radius: var(--gac-radius-md);
  background-color: var(--gac-surface-hover);
}

.defaultImage {
  object-fit: contain;
}

/* One plate shape, four meanings — the colour comes from the status tokens rather than from a
   hex per state, so the rental screen reads the same as the rest of the app in either theme. */
.plate {
  border-radius: var(--gac-radius-pill);
  padding: var(--gac-space-sm) var(--gac-space-xs);
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-content: center;
  gap: var(--gac-space-sm);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-line-border);
}

.plateSuccess {
  border-color: var(--gac-status-success);
}

.plateWarning {
  border-color: var(--gac-status-warning);
}

.plateDanger {
  border-color: var(--gac-status-danger);
}

.plateMuted {
  border-color: var(--gac-line-divider);
}

.section {
  width: 100%;
  padding: var(--gac-space-sm) var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-line-border);
  box-sizing: border-box;
}

.error {
  width: 100%;
  padding: var(--gac-space-xs) var(--gac-space-sm);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-status-danger);
  box-sizing: border-box;
}

.actionButton {
  width: 100%;
  margin-top: var(--gac-space-xxs);
}

.row {
  display: flex;
  justify-content: space-between;
  gap: var(--gac-space-sm);
}
